import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicNonlinearPDE = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="SOLVING NON-LINEAR PDE"
      videos={[
        "https://www.youtube.com/embed/ongICvz1BsQ",
        "https://www.youtube.com/embed/9DZJKKwRkUk",
        "https://www.youtube.com/embed/OZuvIY5IeAw",
        "https://www.youtube.com/embed/MoDc_BAHB9k",
        "https://www.youtube.com/embed/l_UMobKj_wM",
        "https://www.youtube.com/embed/7BCBnsDq7Tc",
      ]}
      takeaways={[
        { text: "check if this topic is in the syllabus or not,as the syllabus is updated" },
        { text: "Type-1:" },
        { text: "- First video: How to solve" },
        { text: "Type-2:" },
        { text: "- Second video: How to solve" },
        { text: "Type-3: F(z,p,q), F(x,p,q), F(y,p,q)" },
        { text: "- Third video: F(z,p,q)" },
        { text: "- Fourth video: F(x,p,q)" },
        { text: "- Fifth video: F(y,p,q)" },
        { text: "Type-4:" },
        { text: "- Sixth video: How to solve" },
        { text: "Practice as many problems as you can" },
      ]}
      questions={[]} // Empty questions as there were none provided
      exampleVideos={[]} // Empty example videos
    />
  );
}

export default ModuleSubtopicNonlinearPDE;